export { useWallet } from "./useWallet";
export { useAuth } from "./useAuth";
export { useClickOutside } from "./useClickOutside";
export { useDropdownPosition } from "./useDropdownPosition";
export { useToast } from "./useToast";
export { useBodyScrollLock } from "./useBodyScrollLock";
export {
  useValidatorEligibility,
  getValidatorEligibility,
} from "./useValidatorEligibility";
export type { UseValidatorEligibilityResult } from "./useValidatorEligibility";

// TanStack Query hooks
export * from "./mutations";
export * from "./queries";
